import React from 'react';
import { TaxMapsSearchResult, Item } from '../../models';
import { Divider, Card, Typography, Table, Button, Empty } from 'antd';
import {
  CommonTable,
  IconTypeNames,
  TableSizeNames,
  ButtonShapes,
} from 'common';
import { COLUMN_NAMES, exportReport } from 'pages/TaxMaps';
import { useDispatch } from 'react-redux';
import { useAccount, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { getAccessToken } from 'common/helpers';

const { Title } = Typography;
const { Column } = Table;

const TaxMapResultTable: React.FC<{
  data: TaxMapsSearchResult;
}> = ({ data: { items, searchCriteria, searchId } }) => {
  const dispatch = useDispatch();
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  const exportReportClick = (
    middleName: string,
    imageId: number,
    imageName: string,
    format: string,
  ) => {
    if (account && inProgress === InteractionStatus.None) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken)
          dispatch(
            exportReport(
              searchId,
              middleName,
              imageId,
              imageName,
              format,
              response.accessToken,
            ),
          );
      });
    }
  };

  const getRender =
    (columnName: string, dispatch: any) => (text: string, record: Item) => {
      switch (columnName) {
        case COLUMN_NAMES.taxMapImageId.dataIndex: {
          return (
            <>
              <Button
                type="link"
                shape={ButtonShapes.ROUND}
                size={TableSizeNames.SMALL}
                icon={IconTypeNames.DOWNLOAD}
                onClick={() => {
                  exportReportClick(
                    record.taxMapImageId > 0 ? 'image' : 'fileId',
                    record.taxMapImageId > 0
                      ? record.taxMapImageId
                      : record.taxMapFileId,
                    searchCriteria.toLowerCase().replace(':', ''),
                    'pdf',
                  );
                }}
              >
                {`Download as PDF`}
              </Button>
              {record.taxMapImageId !== 0 && record.filesCount === 1 && (
                <Button
                  type="link"
                  shape={ButtonShapes.ROUND}
                  size={TableSizeNames.SMALL}
                  icon={IconTypeNames.DOWNLOAD}
                  onClick={() => {
                    exportReportClick(
                      'image',
                      record.taxMapImageId,
                      searchCriteria.toLowerCase().replace(':', ''),
                      'tiff',
                    );
                  }}
                >
                  {`Download as TIFF`}
                </Button>
              )}
            </>
          );
        }
        default:
          return text;
      }
    };

  return (
    <>
      <Divider dashed />
      <Card size="small">
        <Title>Reports</Title>
        <Title level={4}>Search Criteria: {searchCriteria}</Title>
        {items.length > 0 ? (
          <CommonTable items={items} rowKey={'taxMapImageId'}>
            {Object.values(COLUMN_NAMES).map(({ title, dataIndex }, index) => (
              <Column
                {...{
                  title,
                  dataIndex,
                  render: getRender(dataIndex, dispatch),
                }}
                key={index}
              />
            ))}
          </CommonTable>
        ) : (
          <Empty description="No Maps Found" />
        )}
      </Card>
    </>
  );
};

export default TaxMapResultTable;
